// extracted by mini-css-extract-plugin
export default {"educationContainer":"educationContainer_C4Ub","education":"education_jycK"};